import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../functions/server';

class View extends React.Component {

  state = {

  }

  brand = (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('Access Defined!!!!');
      return;
    }
    this.check(value, this.props.value)
  }

  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  add(brand) {
    let context = this;
    let data = {'branchId': this.props.branch, 'brand': brand};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'branchandbrand/insert.php';
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
          context.props.getBranchAndBrand();
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  remove(id) {
    let context = this;
    let data = {'branchId': this.props.branch, 'brand': id};
    context.setState({
      load: true,
      message: 'Adding Executive!!!'
    })
    let url = Server() + 'branchandbrand/remove.php';
    $.ajax({
      type: 'POST',
      data: data,
      url: url,
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
          })
          context.props.getBranchAndBrand();
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  render() {
    return (
      <div>
        <Dropdown placeholder='Brand' style={{ borderColor: '#5A9CBB' }}
         fluid search multiple selection onChange={this.brand}
         options={this.props.option} value={this.props.value} />
      </div>
    );
  }
}

export default View;
